/// <reference path="../../../app.definition.ts" />

import { CrProfile } from "@common/model/crProfile";
import { Subject } from "@common/model/subject";
import angular from "angular";
import { CacheService } from "@common/service/cache.service";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { PopUpService } from "@common/popup/popup.service";
import { IBroadcastService } from "@common/service/broadcast.service";
import { SubjectService } from "@common/service/subject.service";
import { IAppRootScopeService } from "@/app/app.definition";

interface IEcvCrProfile {
  subject: Subject;
  aboutText: string;
  defaultAboutText: string;
  aboutEditMode: boolean;
  careDetails: Array<any>;
  careDetailTypes: Array<any>;
  saveEnabled: boolean;
  subjectLoaded: boolean;
  isOwner: boolean;
  blog: Array<any>;
  subjectId: number
  subjectImages: Array<any>;
  saveCallback: Function;
  cancelCallback: Function;
  displayChoices: boolean;
  cssPrefix: string;
  enableChoices: boolean;
  mugshotEditTooltip: string;
  totalGoals: number;
  init(): void;
  toggleAboutEditMode(state: boolean): void;
  resetAboutText(): void;
  addCareDetail(evt: any): void;
  removeCareDetail(index: number, evt: any): void;
  editCareDetail(index: number): void;
  saveCrProfile(full: boolean): void;
  resetCrProfile(): void;
  loadSubjectImages();
  onChangeCallback(index: number): void;
  onBlurCallback(index: number, type: string): void;
  onFocusCallback(index: number, type: string): void;
  onAboutFocusCallback(): void;
  toggleEditMode(state: boolean, evt?: any): void;
  saveAllFields(full: boolean): void;
  initCareDetails(edit?: boolean): void;
  addCrPhoto($file, $errFiles, subject?): void;
  refreshSubject(): void;
}

class EcvCrProfile implements IEcvCrProfile {
  subject: Subject;
  aboutText: string;
  aboutAddedBy: number;
  defaultAboutText: string;
  aboutEditMode: boolean = false;
  careDetails: Array<any>;
  careDetailTypes: Array<any>;
  selectedCareDetail: number;
  prevAboutText: string;
  saveEnabled: boolean;
  careDetailsCopy: Array<any>;
  aboutTextCopy: string;
  subjectLoaded: boolean;
  isOwner: boolean;
  user: any;
  blog: Array<any>;
  displayChoices: boolean;
  subjectId: number;
  subjectImages: Array<any>;
  saveCallback: Function;
  cancelCallback: Function;
  aboutModified: boolean;
  cssPrefix: string;
  crProfileFocus: boolean = false;
  enableChoices: boolean;
  mugshotEditTooltip: string;
  totalGoals: number;

  static $inject = ["CacheService", "ApiAdapterService", "$rootScope", "$scope", "$timeout", "PopUpService", "BroadcastService", "SubjectService"];
  projGoal: any;
  constructor(
    private $_cache: CacheService,
    private ApiAdapterService: JavaApiAdapterService,
    private $rootScope: IAppRootScopeService,
    private $scope: ng.IScope,
    private $timeout: ng.ITimeoutService,
    private PopUpService: PopUpService,
    private BroadcastService: IBroadcastService,
    private $_sub: SubjectService
  ) {
    const context = this;
    angular.element('.cr-profile-modal').click(function (event) {
      if (!angular.element(event.target).closest('.cr-profile').length) {
        context.saveAllFields(true);
      }
    });

    $scope.$on('$destroy', () => {
      this.BroadcastService.removeCallBack('update-gallery', this.$rootScope.$id);
      this.BroadcastService.removeCallBack('reload-cr-profile', this.$scope.$id);
      this.BroadcastService.removeCallBack('update-cr-profile', this.$scope.$id);
      this.BroadcastService.removeCallBack('save-cr-profile', this.$scope.$id);
      this.BroadcastService.removeCallBack('refresh-cr', this.$rootScope.$id);
    });
  }

  init(): void {
    // flag to toggle the spinner icon
    this.subjectLoaded = false;
    this.crProfileFocus = false;
    this.user = this.$_cache.getUser();

    const process = () => {
      if (!!this.subject) {
        // display readOnly content to the Team Members
        if (this.subject.ownerId == this.user.id) {
          this.isOwner = true;
        } else {
          this.isOwner = false;
        }

        // display default text if about is blank
        if (this.aboutText == null || this.aboutText == "") {
          if (this.subject.subjectTypeId == 'INDIVIDUAL') {
            this.defaultAboutText = "Share something fun or interesting about " +
              this.subject.firstName +
              " here! This content will be visible to everyone on your Team.";
          } else {
            this.defaultAboutText = "Share important information about the Project here! This content will be visible to everyone on your Team.";
          }
        }

        if (!!this.cssPrefix) {
          //do something
        } else {
          this.cssPrefix = '';
        }

        // fetch the list of careDetailTypes
        this.ApiAdapterService.getCareDetails(this.subject.subjectTypeId).then((s) => {
          this.careDetailTypes = s;

          // fetch the care recipient's profile details
          this.ApiAdapterService.getCrProfile(this.subject.subjectId).then((s) => {

            // save the details as a copy for use on reset
            this.aboutTextCopy = (!!s.about ? s.about : "");
            if (!!this.aboutTextCopy) {
              this.aboutTextCopy = this.aboutTextCopy.replace(/<\/br\/?>/gi, '\r\n');
            }
            this.careDetailsCopy = s.subjectCareDetails;
            this.aboutAddedBy = s.aboutAddedBy;

            // initialize the careDetails object
            this.initCareDetails();
          }, (e) => {
            this.aboutTextCopy = "";
            this.careDetailsCopy = [];
            this.aboutAddedBy = null;
            this.subjectLoaded = true;
            console.log("Error: " + e);
          });

        }, (e) => {
          console.log("Error: " + e);
        });

        this.ApiAdapterService.getSubjectImages(this.subject.subjectId).then((s) => {
          this.subjectImages = s;
        }, (e) => {
          this.subjectImages = [];
          console.log(e);
        });

        this.saveEnabled = false;
        this.aboutModified = false;

        if (!!this.subject.photo) {
          this.mugshotEditTooltip = "Change photo";
        } else {
          this.mugshotEditTooltip = "Choose photo";
        }
      } else {
        // initialize the blog object
        this.initBlog();
      }
    }
    if (!this.subjectId) {
      this.subject = this.$_cache.getCurrentSubject();
      process();
    } else {
      this.$_sub.getSubjectById(this.subjectId).then((sub: Subject) => {
        this.subject = sub;
        process();
      })
    }

    this.BroadcastService.registerCallBack('update-gallery', this.$rootScope.$id, () => {
      this.loadSubjectImages();
    });
    this.BroadcastService.registerCallBack('reload-cr-profile', this.$scope.$id, () => {
      this.initCareDetails();
    });
    this.BroadcastService.registerCallBack('update-cr-profile', this.$scope.$id, () => {
      this.init();
    });
    this.BroadcastService.registerCallBack('save-cr-profile', this.$scope.$id, () => {
      this.saveAllFields(false);
    });
    this.BroadcastService.registerCallBack('refresh-cr', this.$rootScope.$id, () => {
      this.refreshSubject();
    });

  }

  // this function initializes the care details
  initCareDetails(edit?: boolean): void {
    const context = this;
    if (this.subject) {
      this.aboutText = this.aboutTextCopy;
      this.aboutModified = false;

      // set the flag to display all careDetailTypes by default
      this.careDetailTypes = this.careDetailTypes.map(function (item) {
        const temp = item;
        item["available"] = true;
        return temp;
      });

      // format the careDetails as needed on the UI
      this.careDetails = this.careDetailsCopy.map(function (item) {

        // remove the used careDetailTypes from the list
        context.removeCareDetailType(item.careDetailId);

        return {
          "id": item.id,
          "careDetailId": item.careDetailId,
          "answer": item.answer.replace(/<\/br\/?>/gi, '\r\n'),
          "typeId": context.getTypeId(item.careDetailId, context),
          "readOnly": (!!edit ? false : true),
          "modified": false,
          "addedBy": item.addedBy
        }
      });

      // flag to toggle the visiblilty of the select box
      this.displayChoices = this.choicesAvailable();
      this.subjectLoaded = true;
      this.totalGoals = this.careDetailsCopy.length;
      if (!!edit) {
        //
      } else {
        this.toggleEditMode(false, null);
      }
    }
  }

  // this function returns the index of the careDetailType in the array
  getTypeId(id: number, context: any): number {
    const filtered = this.careDetailTypes.filter(function (item) {
      return (item.id == id);
    });
    return context.careDetailTypes.indexOf(filtered[0]);
  }

  // this function removes the used careDetailType from the list
  removeCareDetailType(id: number): void {
    const selectedItem = this.careDetailTypes.filter(function (item) {
      return (item.id == id);
    });
    this.careDetailTypes[this.careDetailTypes.indexOf(selectedItem[0])].available = false;
  }

  // this function toggles the readOnly state of the about input box
  toggleAboutEditMode(state: boolean): void {
    this.aboutEditMode = state;
    if (state == true) {
      this.prevAboutText = this.aboutText;

      const context = this;

      // automatically set focus to the aboutText input box
      setTimeout(function () {
        const aboutTextarea = document.getElementById('cr-about-textarea');
        aboutTextarea.focus();
      }, 200);

      context.crProfileFocus = true;
    } else if (state == false) {
      // if (this.aboutText != this.aboutTextCopy && this.aboutAddedBy != this.user.id) {
      //   if (!!this.aboutAddedBy && this.aboutAddedBy != 0) {
      //     this.aboutModified = true;
      //   }
      // } else {
      //   this.aboutModified = false;
      // }
      if (this.prevAboutText !== this.aboutText) {
        this.saveEnabled = true;
      }
    }
  }

  // this function resets the state of the about input box
  resetAboutText(): void {
    this.aboutText = this.prevAboutText;
  }

  // this function adds an empty careDetail to the list
  addProjectGoal(evt: any): void {
    if (!!evt) {
      evt.stopPropagation();
    }
    const context = this;
    this.careDetails.push(
      {
        careDetailId: this.careDetailTypes[0].id,
        answer: this.projGoal,
        modified: true,
        readOnly: false
      }
    );
    this.totalGoals += 1;
    this.projGoal = "";
    this.saveEnabled = true;
  }
  // this function adds an empty careDetail to the list
  addCareDetail(evt: any): void {
    if (!!evt) {
      evt.stopPropagation();
    }
    const context = this;
    const selectedItem = this.careDetailTypes.filter(function (item) {
      return (item.id == context.selectedCareDetail);
    });
    if (selectedItem.length > 0) {
      this.careDetails.push(
        {
          typeId: this.careDetailTypes.indexOf(selectedItem[0]),
          careDetailId: selectedItem[0].id,
          answer: '',
          readOnly: false
        }
      );

      // remove the used careDetailType from the list
      this.careDetailTypes[this.careDetailTypes.indexOf(selectedItem[0])].available = false;
      this.selectedCareDetail = null;
      this.saveEnabled = true;
      this.displayChoices = this.choicesAvailable();

      this.$timeout(() => {
        angular.element('#' + this.cssPrefix + 'cd_' + (this.careDetails.length - 1).toString()).focus();
      }, 0);
    }
  }

  // this function removes the selected careDetail from the list
  removeCareDetail(index: number, evt: any): void {
    if (!!evt) {
      evt.stopPropagation();
    }
    const context = this;
    const selectedItem = this.careDetailTypes.filter(function (item) {
      return (item.id == context.careDetails[index].careDetailId);
    });

    // add the careDetailType back to the list
    this.careDetailTypes[this.careDetailTypes.indexOf(selectedItem[0])].available = true;
    if (!!this.careDetails[index].id) {
      this.careDetails[index].deleted = true;
      this.careDetails[index].modified = true;
    } else {
      this.careDetails.splice(index, 1);
    }
    this.totalGoals -= 1;
    this.displayChoices = this.choicesAvailable();
    this.enableChoices = true;
  }

  // this function disables the readOnly state of the careDetail input box
  editCareDetail(index: number): void {
    this.careDetails[index].readOnly = false;
    this.saveEnabled = true;
    angular.element('#' + this.cssPrefix + 'cd_' + (index).toString()).focus();
  }

  // this function saves the care recepient profile details
  saveCrProfile(full: boolean): void {
    const context = this;
    let aboutModifiedByUser = false;
    if (this.aboutText != this.aboutTextCopy) {
      this.aboutModified = true;
    } else {
      this.aboutModified = false;
    }
    if (!!this.isOwner) {
      // do nothing
    } else {
      if (this.aboutText != this.aboutTextCopy && this.aboutAddedBy != this.user.id) {
        if (!!this.aboutAddedBy && this.aboutAddedBy != 0) {
          aboutModifiedByUser = true;
        }
      } else {
        aboutModifiedByUser = false;
      }
    }

    if (!!this.projGoal) {
      this.careDetails.push(
        {
          careDetailId: this.careDetailTypes[0].id,
          answer: this.projGoal,
          modified: true,
          readOnly: false
        }
      );
      this.projGoal = "";
    }

    const modifiedCareDetails = this.careDetails.filter(function (detail) {
      return detail.modified == true;
    });

    const modifiedByUserCareDetails = this.careDetails.filter(function (detail) {
      return (detail.modified == true && (!!detail.addedBy && detail.addedBy != context.user.id));
    });

    if (modifiedCareDetails.length > 0 || this.aboutModified == true) {
      this.performSaveCrProfile(full);
    } else {
      this.toggleEditMode(false, null);
    }

  }

  performSaveCrProfile(full: boolean): void {
    const context = this;

    // format the details as needed by the API
    let details = this.careDetails.map(function (item) {
      const obj = {
        "careDetailId": item.careDetailId,
        "answer": item.answer,
        "subjectId": context.subject.subjectId,
        "modified": item.modified
      };
      if (!!item.id) {
        obj["id"] = item.id;
      }
      if (item.deleted == true) {
        obj["deleted"] = item.deleted;
      }
      if (obj['answer'] == "" && !!obj['id']) {
        obj['answer'] = "null";
        obj['deleted'] = true;
      }
      return obj;
    });

    // remove the empty details from the list
    details = details.filter(function (item) {
      if (!!item.answer && !!item.modified && item.modified == true) {
        return true;
      } else {
        if (!!item['id'] && !!item.modified && item.modified == true) {
          return true;
        }
      }
      return false;
    });

    const crProfile = new CrProfile();
    crProfile.about = this.aboutText;
    crProfile.subjectId = this.subject.subjectId;
    crProfile.subjectCareDetails = details;

    // call the api to save the details
    this.ApiAdapterService.updateCrProfile(crProfile).then((s) => {
      this.aboutTextCopy = (!!s.about ? s.about : "");
      this.aboutTextCopy = this.aboutTextCopy.replace(/<\/br\/?>/gi, '\r\n');
      this.careDetailsCopy = s.subjectCareDetails;
      this.aboutAddedBy = s.aboutAddedBy;
      this.totalGoals = s.subjectCareDetails.length;
      // display the updated details
      // this.initCareDetails();
      if (!!full) {
        this.BroadcastService.broadcast('update-cr-profile');
      } else {
        this.BroadcastService.broadcast('reload-cr-profile');
      }

      this.saveEnabled = false;
      this.crProfileFocus = false;
    }, (e) => {
      console.log(e);
    });

    if (!!this.saveCallback) {
      this.saveCallback(this);
    }
  }

  // this function resets the state of the care recipient profile details
  resetCrProfile(): void {
    this.initCareDetails(true);
    this.saveEnabled = false;
    this.projGoal = "";
    if (!!this.cancelCallback) {
      this.cancelCallback(this);
    }
  }

  resetAndRemoveEditCrProfile(): void {
    this.resetCrProfile();
    this.toggleEditMode(false);
  }

  // load the image gallery
  loadSubjectImages(): void {
    this.ApiAdapterService.getSubjectImages(this.subject.subjectId).then((s) => {
      this.subjectImages = s;
      this.$rootScope.imageUploading = false;
    }, (e) => {
      this.subjectImages = [];
      console.log(e);
    });
  }

  // this function initializes the blog details
  initBlog() {
    this.blog = [
      {
        "title": "CSAs and Networked Coordination: Bridging The Gaps In Care",
        "img": "/src/client/assets/images/blog/1.jpg",
        "link": "https://ecarevault.com/2017/07/acos-csas-managed-care/"
      },
      {
        "title": "3 Reasons To Record Your Child’s Summer For Their Special Education Team",
        "img": "/src/client/assets/images/blog/2.jpg",
        "link": "https://ecarevault.com/2017/06/special-education-team-and-your-child-summer/"
      },
      {
        "title": "Tales Of A Special Education Journey And Being A Single Parent",
        "img": "/src/client/assets/images/blog/3.jpg",
        "link": "https://ecarevault.com/2017/06/special-education-meets-autism/"
      }
    ];
  }
  // this functions returns true if choices are available, false otherwise
  choicesAvailable(): boolean {
    const temp = this.careDetailTypes.filter(function (item) {
      return item['available'] == true;
    });
    return (temp.length > 0);
  }

  // this function adds the modified flag to the careDetail
  onChangeCallback(index: number): void {
    if (!!this.careDetails[index].answer) {
      if (this.careDetailsCopy[index] == undefined || this.careDetailsCopy[index] == null) {
        this.careDetails[index].modified = true;
      } else if (this.careDetailsCopy[index].answer != this.careDetails[index].answer) {
        this.careDetails[index].modified = true;
      } else if (this.careDetailsCopy[index].answer == this.careDetails[index].answer) {
        this.careDetails[index].modified = false;
      }
    } else if (!!this.careDetails[index]['id']) {
      this.careDetails[index].modified = true;
    }
  }

  onBlurCallback(index: number, type: string): void {
    angular.element('#' + this.cssPrefix + type + 'fld_' + (index).toString()).removeClass('fld-active');
  }

  onFocusCallback(index: number, type: string): void {
    this.crProfileFocus = true;
    angular.element('#' + this.cssPrefix + type + 'fld_' + (index).toString()).addClass('fld-active');
  }

  onAboutFocusCallback(): void {
    this.crProfileFocus = true;
  }

  saveAllFields(full: boolean): void {
    if (this.crProfileFocus == true) {
      this.saveCrProfile(full);
      this.crProfileFocus = false;
    }
  }

  toggleEditMode(state: boolean, evt?: any): void {
    if (!!evt) {
      evt.stopPropagation();
    }
    if (state == true) {
      if (this.careDetails.length != this.careDetailTypes.length) {
        this.displayChoices = true;
        this.enableChoices = true;
      }
      this.toggleAboutEditMode(true);
      for (let c = 0; c < this.careDetails.length; c++) {
        this.careDetails[c].readOnly = false;
      }
    } else if (state == false) {
      for (let c = 0; c < this.careDetails.length; c++) {
        if (!!this.careDetails[c].answer) {
          //do something
        } else {
          const context = this;
          const selectedItem = this.careDetailTypes.filter(function (item) {
            return (item.id == context.careDetails[c].careDetailId);
          });
          this.careDetailTypes[this.careDetailTypes.indexOf(selectedItem[0])].available = true;
        }
      }
      if (!!this.careDetails) {
        this.careDetails = this.careDetails.filter(function (item) {
          return !!item.answer;
        });
      }
      if (this.careDetails.length > 0) {
        this.displayChoices = false;
      }
      this.enableChoices = false;
      this.toggleAboutEditMode(false);
      for (let c = 0; c < this.careDetails.length; c++) {
        this.careDetails[c].readOnly = true;
      }
    }
  }

  addCrPhoto($file, $errFiles, subject?, $invalidFiles?): void {
    if (!subject.isFrozen) {
      if (!$file) {
        if ($invalidFiles[0].$error == 'maxHeight') {
          $file = $invalidFiles[0];
        } else {
          return;
        }
      }

      const photoPath = $file;
      this.PopUpService.openPhotoPopUp($file).then((s) => {
        const photo64 = s.photo;
        if (!!subject) {
          subject.tempPhoto = photo64;
          subject.photoMimeType = $file.filetype || $file.type;
          this.updateSubject(subject);
        }
      }, (e) => this.PopUpService.openInformationModal(e));
    }
  }

  updateSubject(subject: any) {
    this.$rootScope.mainShowLoader = true;
    if (subject.birthDateShort) {
      subject.birthDate = Date.UTC(subject.birthDateShort.getFullYear(), subject.birthDateShort.getMonth(), subject.birthDateShort.getDate());
    } else {
      subject.birthDate = '';
    }
    if (subject.startDateShort) {
      subject.startDate = Date.UTC(subject.startDateShort.getFullYear(), subject.startDateShort.getMonth(), subject.startDateShort.getDate());
    } else {
      subject.startDate = '';
    }

    if (subject.endDateShort) {
      subject.endDate = Date.UTC(subject.endDateShort.getFullYear(), subject.endDateShort.getMonth(), subject.endDateShort.getDate());
    } else {
      subject.endDate = '';
    }
    if (!!subject.tempPhoto) {
      subject.photo = subject.tempPhoto;
    }
    !!subject.customAttributes && (subject.customAttributes = JSON.stringify(subject.customAttributes));
    this.ApiAdapterService.updateSubject(subject, this.$_cache.getPassword()).then((s) => {
      this.subject = subject;
      const updtCache = (teams) => {
        const indexOfSubject = teams.findIndex(sub => sub.subjectId == this.subject.subjectId);
        (indexOfSubject > -1) && (teams.splice(indexOfSubject, 1, this.subject));
      }

      updtCache(this.$_cache.getSortedSubjects());
      updtCache(this.$_cache.getSubjects());

      setTimeout(() => {
        this.$rootScope.mainShowLoader = false;
        this.BroadcastService.broadcast('reload-feeds', [subject.subjectId]);
      }, 500);

    }, (e) => {
      console.log(e);
      this.$rootScope.mainShowLoader = false;
    });
  }

  refreshSubject() {
    this.subject = this.$_cache.getCurrentSubject();
  }
}

function crProfile(): ng.IDirective {
  return {
    restrict: 'E',
    templateUrl: 'app/common/directive/cr-profile/templates/cr-profile.directive.html',
    replace: true,
    controller: EcvCrProfile,
    controllerAs: 'crProfileVm',
    scope: true,
    bindToController: {
      'subjectId': '=?ecvSubjectId',
      'saveCallback': '=?ecvSaveCallback',
      'cancelCallback': '=?ecvCancelCallback',
      'cssPrefix': '@?ecvCssPrefix'
    },
    link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvCrProfile): void => {
      controller.init();
    }
  }
}

angular.module('eCareVault.common.directives').directive('ecvCrProfile', crProfile);
